export enum SettlementStatus {
  PENDING = 'PENDING',
  DONE = 'DONE',
}
